export const BASENAME = process.env.REACT_APP_BASENAME;
// ,API_URL: process.env.REACT_APP_API_URL
// , BASE_NAME: process.env.REACT_APP_BASENAME
// , BASE_URL: process.env.REACT_APP_BASE_URL
// , GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID
// , GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
// , GOOGLE_RECAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
// , GOOGLE_RECAPTCHA_SECRET_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_SECRET_KEY
